(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/utils.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const currency = svs.utils.format.Currency;
const _svs$utils$products$p = svs.utils.products.productIds,
  BOMBEN = _svs$utils$products$p.BOMBEN,
  FULLTRAFF = _svs$utils$products$p.FULLTRAFF,
  T8 = _svs$utils$products$p.T8,
  T8EXTRA = _svs$utils$products$p.T8EXTRA,
  T8STRYK = _svs$utils$products$p.T8STRYK,
  POWERPLAY = _svs$utils$products$p.POWERPLAY;
const DRAW_STATE = svs.components.tipsen.drawCard.constants.DRAW_STATE;
const _svs$components$sport = svs.components.sport.tipsenShared,
  DrawState = _svs$components$sport.DrawState,
  DisableType = _svs$components$sport.DisableType;
const SportTypes = svs.components.sport.sportTypes.SportTypes;
const _svs$components$sport2 = svs.components.sport.tipsenShared,
  drawStateEnums = _svs$components$sport2.drawStateEnums,
  getDrawStateEnum = _svs$components$sport2.getDrawStateEnum;
const selectAllParticipants = svs.components.sportinfo.matchInfoRedux.selectors.selectAllParticipants;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const _React = React,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const getIconBySportType = sportTypeId => {
  switch (sportTypeId) {
    case SportTypes.Soccer:
      return 'game-soccer';
    case SportTypes.Hockey:
      return 'game-hockey';
    case SportTypes.Bandy:
      return 'game-bandy';
    case SportTypes.Floorball:
      return 'game-floorball';
    case SportTypes.Handball:
      return 'game-handball';
    case SportTypes.Basketball:
      return 'game-basketball';
    case SportTypes.Tennis:
      return 'game-tennis';
    case SportTypes.WinterOlympic:
      return 'game-winter';
    default:
      return 'game-sport';
  }
};
const isDrawBetDisabled = draw => {
  var _draw$regBetDisabled;
  return ((_draw$regBetDisabled = draw === null || draw === void 0 ? void 0 : draw.regBetDisabled) !== null && _draw$regBetDisabled !== void 0 ? _draw$regBetDisabled : DisableType.Regbet) === DisableType.NotDisabled;
};
const getDrawState = draw => {
  const isRegBetDisabled = isDrawBetDisabled(draw);
  const isOpened = draw.drawStateId === DrawState.Opened;
  const isCancelled = draw.cancelled;
  let state;
  if (!isRegBetDisabled) {
    state = DRAW_STATE.TEMPORARY_CLOSED;
  } else if (isCancelled) {
    state = DRAW_STATE.CANCELLED;
  } else if (!isOpened) {
    state = DRAW_STATE.NOT_OPENED;
  } else if (getDrawStateEnum(draw.drawStateId) === drawStateEnums.LIVE) {
    state = DRAW_STATE.IS_LIVE;
  }
  return state;
};
const getFundInfoToShow = fund => {
  const extraMoney = {};
  if (!fund) {
    return extraMoney;
  }
  const jackpotValues = fund !== null && fund !== void 0 && fund.jackpots ? fund.jackpots[0] : undefined;
  const extraMoneyFromFund = fund !== null && fund !== void 0 && fund.extraMoney && parseInt(fund.extraMoney, 10) > 0 ? fund.extraMoney : undefined;
  const rollOverInFromFund = fund !== null && fund !== void 0 && fund.rolloverIn && parseInt(fund.rolloverIn, 10) > 0 ? fund.rolloverIn : undefined;
  if (jackpotValues && !(jackpotValues !== null && jackpotValues !== void 0 && jackpotValues.defaultJackpot)) {
    extraMoney.isJackpot = true;
    extraMoney.amount = currency(jackpotValues.jackpotAmount);
  } else if (jackpotValues !== null && jackpotValues !== void 0 && jackpotValues.defaultJackpot) {
    extraMoney.isGuaranteeJackpot = true;
    extraMoney.amount = currency(jackpotValues.guaranteedJackpotAmount);
  } else if (extraMoneyFromFund) {
    extraMoney.isExtraMoney = true;
    extraMoney.amount = currency(extraMoneyFromFund);
  } else if (rollOverInFromFund) {
    extraMoney.isRolloverIn = true;
    extraMoney.amount = currency(rollOverInFromFund);
  }
  if (fund.productId === FULLTRAFF && (rollOverInFromFund || extraMoneyFromFund)) {
    extraMoney.isExtraMoneyAndJackpot = true;
    extraMoney.amountForExtraMoneyWithJackpot = currency(rollOverInFromFund) || currency(extraMoneyFromFund);
  }
  return extraMoney;
};
const getLeagueInfo = leaguesAccumulatedInOrder => {
  const hasLeaguesToShow = (leaguesAccumulatedInOrder === null || leaguesAccumulatedInOrder === void 0 ? void 0 : leaguesAccumulatedInOrder.length) > 0;
  if (!hasLeaguesToShow) {
    return null;
  }
  const leagueNameToShow = leaguesAccumulatedInOrder[0].name || leaguesAccumulatedInOrder[0].uniqueLeagueName;
  const hasMoreThanOneLeague = leaguesAccumulatedInOrder.length > 1;
  const leagueToShow = hasMoreThanOneLeague ? "".concat(leagueNameToShow, " +").concat(leaguesAccumulatedInOrder.length - 1) : leagueNameToShow;
  return leagueToShow;
};
const composeTitle = _ref => {
  let drawComment = _ref.drawComment,
    description = _ref.description,
    productId = _ref.productId,
    betIndex = _ref.betIndex,
    regCloseTime = _ref.regCloseTime;
  if (productId === BOMBEN) {
    let title = drawComment || description;
    if (typeof betIndex === 'number' && betIndex > 0) {
      if (/^Bomben, [234] matcher$/i.test(title) || title.toLowerCase().trim() === 'bomben') {
        title = "Bomben ".concat(betIndex);
      }
    }
    return title;
  }
  if ([POWERPLAY, T8, T8STRYK, T8EXTRA].indexOf(productId) >= 0) {
    return dateFns.format(new Date(regCloseTime), 'EEEE', {
      locale: dateFns.locales.sv
    });
  }
  return "Vecka ".concat(dateFns.getISOWeek(new Date(regCloseTime)));
};
const composeHref = (drawNumber, productId) => {
  let returnUrl = '';
  if ([T8, T8EXTRA, T8STRYK].indexOf(productId) >= 0) {
    returnUrl += "?draw=".concat(drawNumber, "&product=").concat(productId);
  } else {
    returnUrl += "?draw=".concat(drawNumber);
  }
  return returnUrl;
};
const useComposeBetEventsWithParticipants = (betEvents, drawId) => {
  const allParticipants = useSelector(selectAllParticipants);
  return useMemo(() => {
    const uniqueMatchIds = new Set();

    const uniqueBetEvents = betEvents.filter(betEvent => {
      if (betEvent.eventTypeId === EventTypeId.RESULT && uniqueMatchIds.has(betEvent.matchId)) {
        return false;
      }
      uniqueMatchIds.add(betEvent.matchId);
      return true;
    });
    return uniqueBetEvents.map(betEvent => {
      var _betEvent$participant;
      const _ref2 = (_betEvent$participant = betEvent === null || betEvent === void 0 ? void 0 : betEvent.participants) !== null && _betEvent$participant !== void 0 ? _betEvent$participant : [],
        _ref3 = _slicedToArray(_ref2, 2),
        homeParticipantId = _ref3[0],
        awayParticipantId = _ref3[1];
      const awayParticipant = allParticipants[awayParticipantId];
      const homeParticipant = allParticipants[homeParticipantId];
      return {
        betEventId: "".concat(drawId, "_").concat(betEvent.eventNumber),
        homeParticipant: {
          participantId: homeParticipantId,
          flagISO: homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.isoCode,
          name: homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.name,
          mediumName: homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.mediumName
        },
        awayParticipant: {
          participantId: awayParticipantId,
          flagISO: awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.isoCode,
          name: awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.name,
          mediumName: awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.mediumName
        }
      };
    });
  }, [allParticipants, betEvents, drawId]);
};
setGlobal('svs.components.tipsen.drawCard.utils', {
  composeHref,
  getDrawState,
  getFundInfoToShow,
  getLeagueInfo,
  composeTitle,
  useComposeBetEventsWithParticipants,
  isDrawBetDisabled,
  getIconBySportType
});

 })(window);